import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "enumDisplay" })
export class EnumDisplayPipe implements PipeTransform {
    transform(value: number | string, enumType: any): string {
        // If the enum is invalid or undefined
        if (!enumType || value === undefined || value === null) return "";

        // Try to get the enum key by value
        const enumKey = enumType[value];
        if (enumKey === undefined) return "";

        // Prettify the name
        return this.prettify(enumKey);
    }

    private prettify(value: string): string {
        // Convert pascalCase or UPPER_CASE to something human readable
        return value
            .replace(/_/g, " ")
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/\b\w/g, (c) => c.toUpperCase());
    }
}
